import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  GestaoEpiForm,
  GestaoEpiSchema,
} from "../../../schemas/CadastroEpi_lista/gestao_epi";
import { useEffect } from "react";
import { GestaoEpi } from "../../../../domain/models/gestao_epi";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedGestaoEpi: GestaoEpi | null;
  onClose: () => void;
  onSubmit: (form: GestaoEpiForm) => void;
};

export const GestaoEpiModal = ({
  open,
  saving,
  loading,
  selectedGestaoEpi,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<GestaoEpiForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(GestaoEpiSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedGestaoEpi) {
        hookForm.setValue("nome", selectedGestaoEpi.nomeEpi ?? "");
        hookForm.setValue("ativo", selectedGestaoEpi.ativo ? 1 : 0);
        hookForm.setValue(
          "especificacao",
          selectedGestaoEpi.especificacao ?? "",
        );
        hookForm.setValue("idGestaoEpi", selectedGestaoEpi.idGestaoEpi);
      } else {
        hookForm.reset({ ativo: 1 });
      }
    }
  }, [open, selectedGestaoEpi, hookForm]);

  const isEdicao = !!selectedGestaoEpi;

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={isEdicao ? "Editar EPI" : "Novo EPI"}
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}
    >
      <div className="w-full flex flex-col gap-4 my-4">
        <div className="flex flex-row gap-6 items-center">
          <div>
            <FormRadioGroupInput
              name="ativo"
              label="Status"
              options={[
                { id: 1, label: "Ativo" },
                { id: 0, label: "Inativo" },
              ]}
              reactHookForm={hookForm}
            />
          </div>
          {isEdicao && (
            <div className="w-1/4">
              <DefaultFormInput
                name="idGestaoEpi"
                label="Codigo"
                reactHookForm={hookForm}
                readOnly={true}
              />
            </div>
          )}
        </div>

        <DefaultFormInput
          name="nome"
          label="Nome do EPI"
          multiline={true}
          rows={2}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name="especificacao"
          label="Tipo/Numeração"
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
};
